import { NOOP } from '@hlj/hlj-utils'

export default {
  store: {
    $list: [],
    $loading: false,
    $pagination: {
      showQuickJumper: true,
      showTotal: total => `共 ${total} 条`,
      showSizeChanger: true,
      current: 1,
      pageSize: 10,
      total: 0
    },
    $getList: NOOP,
    $paging: NOOP,
    $selectedRowKeys: [],
    $onSelectChange: NOOP,
    $editedFields: {}
  },
  //componentDidMount之后是否去getList
  shouldGetListWhenDidMount: true,
  rowKey: 'id',
  //自定义多选框
  rowSelection: null,
  /*
   selectabled为true时表格最前面出现可选复选框
   选中复选框的默认操作会注入到BaseTableStore中的$selectedRowKeys中
   */
  selectabled: false,
  columns: [],
  style: {}
}
